import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './AwardPrizeIcon.css';


const cx = classNames.bind(styles);

const rankClasses = {
  1: 'first',
  2: 'second',
  3: 'third',
  default: 'rest',
};

function AwardPrizeIcon({ type, rank }) {
  return <i className={cx('icon', `icon--${type}${rankClasses[rank] || rankClasses.default}`)} />;
}

AwardPrizeIcon.defaultProps = {
  type: 'month',
  rank: 1,
};

AwardPrizeIcon.propTypes = {
  rank: PropTypes.number,
  type: PropTypes.oneOf(['day', 'month']),
};

export default AwardPrizeIcon;
